module.exports = __webpack_public_path__ + "static/media/rightIcon.3009e98c.svg";